import React, { useState } from "react";
import SFPopover from "../popover";
import { SFInfoIcon } from "../icons";
import SFIconButton from "../button/iconButton";
import { Typography } from "@mui/material";
import { SFStack } from "../grid";
import getStyled from "../../hooks/getStyled";

const { styled } = getStyled();

const StyledTooltipWrapper = styled(SFStack)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const SFPopoverStyled = styled(SFPopover)(({ width }) => ({
  zIndex: 9999,
  ...(width && { "& .MuiPopover-paper": { width } }),
}));

const SFTooltipButtonIcon = ({
  tooltip,
  container,
  position = "bottom-start",
  width,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  return (
    <>
      <SFIconButton onClick={handleClick}>
        <SFInfoIcon size="small" />
      </SFIconButton>
      <SFPopoverStyled
        anchorEl={anchorEl}
        position={position}
        variant="popover"
        container={container}
        onClose={(event) => {
          event.stopPropagation();
          setAnchorEl(null);
        }}
        width={width}
      >
        {typeof tooltip === "string" ? (
          <Typography style={{ margin: 10, maxWidth: 400 }}>
            {tooltip}
          </Typography>
        ) : (
          <StyledTooltipWrapper>{tooltip}</StyledTooltipWrapper>
        )}
      </SFPopoverStyled>
    </>
  );
};

export default SFTooltipButtonIcon;
